import i18n, { SUPPORTED_LANGS } from './index'

const isPlainObject = value =>
  value !== null && typeof value === 'object' && !Array.isArray(value)

const normalizeLang = lang => {
  const base = String(lang || '').split('-')[0]
  return SUPPORTED_LANGS.includes(base) ? base : 'en'
}

const mergeLocalized = (base, override) => {
  if (!isPlainObject(base) || !isPlainObject(override)) return override
  const out = { ...base }
  for (const key of Object.keys(override)) {
    out[key] = mergeLocalized(base[key], override[key])
  }
  return out
}

// Returns a copy of the DB document with the content fields replaced by the
// selected language, falling back to the base (English) fields.
export function localizeContent (doc, lang) {
  if (!doc || typeof doc !== 'object') return doc
  const code = normalizeLang(lang || i18n.language || i18n.resolvedLanguage)
  const localized = doc.translations?.[code] || {}
  const merged = mergeLocalized(doc, localized)
  if (Object.prototype.hasOwnProperty.call(merged, 'translations')) {
    delete merged.translations
  }
  return merged
}
